import { action, makeObservable, observable, computed } from 'mobx';
import { UserUpdateFunction } from './user-update.service';
import { UserProfile, UpdateUserData } from './user.type';

export default class UserStore {
  user: UserProfile | null = null;
  loaded: boolean = false;
  isLoading: boolean = false;
  isReturningUser: boolean = false;
  private unsubscribe?: () => void;

  constructor(update: UserUpdateFunction) {

    makeObservable(this, {
      loaded: observable,
      user: observable,
      isLoading: observable,
      isReturningUser: observable,
      update: action,
      updateUserData: action,
      setLoading: action,
      clearUser: action,
      setReturningUser: action,
      isAuthenticated: computed,
      userDisplayName: computed,
    });

    this.unsubscribe = update((user) => {
      this.update(user);
    });

  };

  update(user: UserProfile | null) {
    this.user = user;
    this.loaded = true;
    this.isLoading = false;
  }

  updateUserData(updates: UpdateUserData) {
    if (this.user) {
      this.user = {
        ...this.user,
        ...updates,
        updatedAt: new Date().toISOString(),
      };
    }
  }

  setLoading(loading: boolean) {
    this.isLoading = loading;
  }

  setReturningUser(isReturning: boolean) {
    this.isReturningUser = isReturning;
  }

  clearUser() {
    this.user = null;
    this.loaded = false;
    this.isLoading = false;
    this.isReturningUser = false;

    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = undefined;
    }
  }

  get isAuthenticated(): boolean {
    return !!this.user;
  }

  get userDisplayName(): string {
    if (!this.user) return '';
    return `${this.user.firstName} ${this.user.lastName}`.trim() ||
      this.user.email ||
      'Unknown User';
  }
}
